<template>
  <div class="animate__animated animate__fadeInUp">
    <div class="titulo">
      <h3>
        {{obRuta.nombre_ruta}}
      </h3>
    </div>
    <div class="texto pa-2">
      <p v-html="obRuta.texto">
      </p>
    </div>
    <div class="cont-acciones pa-2">
      <accionesContenido
      :idBarrio="obRuta.id_ruta"
      :TieneInundacion="obRuta.Riesgos.Riesgo_I"
      :TieneDeslizamiento="obRuta.Riesgos.Riesgo_D"
      @accionRiesgo="onAccionRiesgo"
      :VerRiesgos="(obRuta.ocultar_riesgos == 0) ? true : false "
      :OcultarNoticias="shouldHideNewsAndTrivia"
      :OcultarTrivia="shouldHideNewsAndTrivia"
       />
    </div>
  </div>
</template>
<script>

import accionesContenido from '../rutas/accionesContenido'
export default {
  components:{
    accionesContenido
  },
  props:{
    obRuta:{},
  },
  data() {
    return {
      colorTitulo:'#00AE42',
    }
  },
  computed: {
    shouldHideNewsAndTrivia() {
      const barrios = [
        '24 de Mayo', 'Codesa', 'Gatazo', 'Isla Piedad',
        'Santa Marta 1', 'Vuelta Larga', 'Otros barrios y/o sectores'
      ]
      console.log(this.obRuta.nombre_ruta)
      return barrios.includes(this.obRuta.nombre_ruta.trim())
    }
  },
  methods: {
    onAccionRiesgo(val){
      if(val === 'deslizamiento'){
        this.$emit('accionDesliz')
      }else{
        this.$emit('accionInundacion')
      }
    }
  },
  watch:{
    obRuta(){
      this.colorTitulo = this.obRuta.color
      // console.log('Desde el component ', this.obRuta)
    }
  }
}
</script>

<style lang="scss" scoped>
.titulo{
  background-color: v-bind(colorTitulo);
  color: #FFFFFF;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
